export default defineNuxtPlugin(async (nuxtApp) => {
  if (process.client) {
    const { setupCalendar } = await import("v-calendar");

    nuxtApp.vueApp.use(setupCalendar, {
      locales: {
        cs: {
          firstDayOfWeek: 2,
          masks: { weekdays: "WW" },
        },
        en: {
          firstDayOfWeek: 1,
          masks: { weekdays: "WW" },
        },
      },
    });
  }
});
